// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The Modal background (overlay) */
.modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5); /* Dark background with transparency */
    display: block !important;
    justify-content: center;
    align-items: center;
    z-index: 9999; /* Make sure it's on top of other elements */
  }
  
  /* The Modal content */
  .modal-content {
    background-color: white;
    padding: 20px;
    border-radius: 5px;
    width: 50%;
    max-width: 650px;
    text-align: center;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); /* Optional for a shadow effect */
    margin:0 auto;
    top:30%
  }
  
  /* Close button styles */
  .close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 24px;
    cursor: pointer;
    color: #333;
  }
  .pdcet {
    color: var(--theme-color2);
    font-size: 52px;
    font-weight: 700;
    line-height: 1.5;
  }
  .pb-2 {
    padding-bottom: .5rem !important;
  }
  .know {
    color: var(--color-dark);
    font-size: 28px;
    font-weight: 700;
  }
  .theme-btn {
    font-size: 14px;
    color: var(--color-white);
    padding: 14px 20px;
    transition: var(--transition);
    text-transform: uppercase;
    position: relative;
    border-radius: 50px 50px 50px 0;
    font-weight: 600;
    letter-spacing: 1px;
    cursor: pointer;
    text-align: center;
    overflow: hidden;
    border: none;
    background: var(--theme-color2);
    box-shadow: var(--box-shadow);
    z-index: 1;
  }
  .theme-btn::before {
    content: "";
    height: 300px;
    width: 300px;
    background: var(--theme-color);
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%) scale(0);
    transition: 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    z-index: -1;
  }
  .theme-btn i {
    margin-left: 5px;
  }

  h3{ font-size: 25px !important; }
  .modal-content img {
    width: 33%;
    margin: auto;
    text-align: center;
    position: absolute;
    bottom: 0;
    right: 0;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Modal.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC,EAAE,sCAAsC;IAC5E,yBAAyB;IACzB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa,EAAE,4CAA4C;EAC7D;;EAEA,sBAAsB;EACtB;IACE,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,wCAAwC,EAAE,iCAAiC;IAC3E,aAAa;IACb;EACF;;EAEA,wBAAwB;EACxB;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,eAAe;IACf,WAAW;EACb;EACA;IACE,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,gCAAgC;EAClC;EACA;IACE,wBAAwB;IACxB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,+BAA+B;IAC/B,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,+BAA+B;IAC/B,6BAA6B;IAC7B,UAAU;EACZ;EACA;IACE,WAAW;IACX,aAAa;IACb,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,qDAAqD;IACrD,qDAAqD;IACrD,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;;EAEA,IAAI,0BAA0B,EAAE;EAChC;IACE,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,QAAQ;EACV","sourcesContent":["/* The Modal background (overlay) */\n.modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5); /* Dark background with transparency */\n    display: block !important;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999; /* Make sure it's on top of other elements */\n  }\n  \n  /* The Modal content */\n  .modal-content {\n    background-color: white;\n    padding: 20px;\n    border-radius: 5px;\n    width: 50%;\n    max-width: 650px;\n    text-align: center;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); /* Optional for a shadow effect */\n    margin:0 auto;\n    top:30%\n  }\n  \n  /* Close button styles */\n  .close-btn {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    font-size: 24px;\n    cursor: pointer;\n    color: #333;\n  }\n  .pdcet {\n    color: var(--theme-color2);\n    font-size: 52px;\n    font-weight: 700;\n    line-height: 1.5;\n  }\n  .pb-2 {\n    padding-bottom: .5rem !important;\n  }\n  .know {\n    color: var(--color-dark);\n    font-size: 28px;\n    font-weight: 700;\n  }\n  .theme-btn {\n    font-size: 14px;\n    color: var(--color-white);\n    padding: 14px 20px;\n    transition: var(--transition);\n    text-transform: uppercase;\n    position: relative;\n    border-radius: 50px 50px 50px 0;\n    font-weight: 600;\n    letter-spacing: 1px;\n    cursor: pointer;\n    text-align: center;\n    overflow: hidden;\n    border: none;\n    background: var(--theme-color2);\n    box-shadow: var(--box-shadow);\n    z-index: 1;\n  }\n  .theme-btn::before {\n    content: \"\";\n    height: 300px;\n    width: 300px;\n    background: var(--theme-color);\n    border-radius: 50%;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translateY(-50%) translateX(-50%) scale(0);\n    transition: 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n    z-index: -1;\n  }\n  .theme-btn i {\n    margin-left: 5px;\n  }\n\n  h3{ font-size: 25px !important; }\n  .modal-content img {\n    width: 33%;\n    margin: auto;\n    text-align: center;\n    position: absolute;\n    bottom: 0;\n    right: 0;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
